import type { HelpFile } from '../../types/help'
import { TypeValuesViewTestIds } from '../../../testids/TypeValuesViewTestIds'

export const typeValuesViewHelp: HelpFile = {
  docPage: '/docs/admin/types',
  texts: {
    [TypeValuesViewTestIds.typeValuesSearch]:
      'Filtert Zeilen über alle Gruppen hinweg nach Code oder übersetzter Bezeichnung. Gruppen ohne Treffer werden ausgeblendet; passende Zeilen bleiben in ihrer Gruppe sichtbar.',
    [TypeValuesViewTestIds.typeValuesNoResults]:
      'Keine Zeile in dieser Typtabelle entspricht der aktuellen Suche. Leeren Sie das Suchfeld, um alle Gruppen wieder anzuzeigen.',
    [TypeValuesViewTestIds.colIcon]: 'Optionales Symbol neben dem Wert in Auswahllisten und Badges.',
    [TypeValuesViewTestIds.colCode]: null,
    [TypeValuesViewTestIds.colUsage]: 'Wie viele Entitäten diesen Wert aktuell referenzieren. Klicken Sie, um die Referenzen anzuzeigen.',
    [TypeValuesViewTestIds.colActive]: null,
    [TypeValuesViewTestIds.colActions]: null,
  },
}
